import { paths } from './paths'
import { getNavRoutes } from './routeAccess'
import { routes } from './routes'
import { useAuthStore } from '@/store/authStore'

/**
 * Where a signed-in user belongs when no particular page was asked for.
 *
 * Not everybody is granted the overview, so a recruiter landing on `/dashboard`
 * — after signing in, after `/`, or by following a stale link — used to be
 * bounced to "access denied" as their first screen. The first navigation entry
 * their access list *does* allow is the honest answer, and it is the same list the
 * sidebar draws from, so the page they land on is the one highlighted beside it.
 *
 * `/unauthorized` is the fallback for an account with no navigable route at all —
 * a state worth showing plainly rather than redirecting in a circle.
 *
 * Lives here rather than in routeAccess.js because it needs the route tree, and
 * that module is imported *by* the tree.
 */
export const landingPathFor = (user) => {
  if (!user) return paths.login
  return getNavRoutes(routes, user, 'main')[0]?.to ?? paths.unauthorized
}

/** The current user's landing path. Recomputed when the session changes. */
export const useLandingPath = () => landingPathFor(useAuthStore((state) => state.user))
